import { render, staticRenderFns } from "./VisualizarPerfilTurmaDialog.vue?vue&type=template&id=d166c848"
import script from "./VisualizarPerfilTurmaDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarPerfilTurmaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports